var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendicon = function SvgSendicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.317 2.553 1.867 5.372a.088.088 0 0 0-.046.03.105.105 0 0 0-.02.053.07.07 0 0 0 .004.036l.004.003a.081.081 0 0 0 .008.005l5.35 2.203 5.15-5.15Zm-4.019 6.28 2.204 5.35.005.009a.027.027 0 0 0 .002.003c.002.001.014.007.037.005a.104.104 0 0 0 .053-.02.088.088 0 0 0 .03-.046l2.818-10.45-5.149 5.15Zm7.466-7.594L12.17 14.564l-.006.019c-.421 1.421-2.475 1.728-3.13.239l-.007-.017-2.285-5.547-5.547-2.285-.017-.007c-1.488-.655-1.181-2.709.24-3.13l.019-.005L14.79.228a.8.8 0 0 1 .973 1.012Z",
    clipRule: "evenodd"
  })));
};
export default SvgSendicon;